import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import {Link} from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import {
    deleteWithAuthCall, getWithAuthCallWithErrorResponse, simplePostCall,
} from "../api/ApiServices";
import swal from "sweetalert";
import {Table} from "react-bootstrap";
import Loading from "../sharedComponents/Loaders/Loading";
import BtnLoader from "../sharedComponents/Loaders/BtnLoader";
import {Pagination} from "./Pagination";
import {PaginationCustomer} from "./PaginationCustomer";

const CouponCode = () => {
    const {sidebar} = useContext(AppContext);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [numPages, setNumPages] = useState(1);
    const changePage = (page) => {
        if (page > 0 && page <= numPages) {
            setCurrentPage(page);
        }
    };


    const [showModalUpdate, setShowModalUpdate] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const handleCloseModalAdd = () => setShowModalAdd(false);
    const handleCloseModalUpdate = () => setShowModalUpdate(false);
    const handleShowModalAdd = () => {
        setAddCouponCodeData({
            code: '', type: '', value: '', start_date: '', end_date: '',
        });
        setShowModalAdd(true)
    };

    const [deleteShow, setDeleteShow] = useState(false);
    const handleDeleteClose = () => {
        setCouponCodeId(null);
        setDeleteShow(false)
    };
    const handleDeleteShow = (categoryId) => {
        setCouponCodeId(categoryId);
        setDeleteShow(true)
    };

    const [viewShow, setViewShow] = useState(false);
    const handleViewClose = () => setViewShow(false);
    const handleViewShow = () => setViewShow(true);

    const [validated, setValidated] = useState(false);

    const [couponCodes, setCouponCodes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [couponCodeId, setCouponCodeId] = useState(null);

    const [addCouponCodeData, setAddCouponCodeData] = useState({
        name: '', code: '', type: '', value: '', start_date: '', end_date: '',
    });

    const [editCouponCodeData, setEditCouponCodeData] = useState({
        id: null, name: '', code: '', type: '', value: '', start_date: '', end_date: '',
    });

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            addCouponCode(event);
        }
        setValidated(true);
    };

    const handleSubmitFormUpdate = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            updateCouponCode(event);
        }
        setValidated(true);
    };

    const addCouponCode = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let reqBody = JSON.stringify({
            name: addCouponCodeData.name,
            code: addCouponCodeData.code,
            type: addCouponCodeData.type,
            value: Number(addCouponCodeData.value),
            start_date: new Date(addCouponCodeData.start_date).toISOString(),
            end_date: new Date(addCouponCodeData.end_date).toISOString(),
        });
        simplePostCall(ApiConfig.ADD_COUPON, reqBody)
            .then((res) => {
                setIsLoading(false);
                handleCloseModalAdd();
                if (res.success) {
                    setAddCouponCodeData({
                        code: '', type: '', value: '', start_date: '', end_date: ''
                    });
                    swal({
                        text: res.message, icon: "success", timer: 2000, dangerMode: false,
                    });
                    getCouponCodes();
                } else {
                    swal({
                        text: res.message, icon: "error", timer: 2000, dangerMode: false,
                    });
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };

    const deleteCategory = () => {
        if (couponCodeId) {
            setIsLoadingDelete(true);
            const url = ApiConfig.DELETE_COUPON + couponCodeId;
            deleteWithAuthCall(url).then((res) => {
                setIsLoadingDelete(false);
                setCouponCodeId(null);
                handleDeleteClose();
                if (res.status === 200) {
                    swal({
                        text: res.message, icon: "success", timer: 2000, dangerMode: false,
                    });
                    getCouponCodes();
                } else {
                    swal({
                        text: res.message, icon: "error", timer: 2000, dangerMode: false,
                    });
                }
            }).catch((err) => {
                setIsLoadingDelete(false);
                console.log(err);
            });
        }
    }

    const updateCouponCode = (event) => {
        event.preventDefault();
        setIsLoading(true);
        let reqBody = JSON.stringify({
            id: editCouponCodeData.id,
            name: editCouponCodeData.name,
            code: editCouponCodeData.code,
            type: editCouponCodeData.type,
            value: Number(editCouponCodeData.value),
            start_date: new Date(editCouponCodeData.start_date).toISOString(),
            end_date: new Date(editCouponCodeData.end_date).toISOString(),
        });

        simplePostCall(ApiConfig.UPDATE_COUPON, reqBody)
            .then((res) => {
                setIsLoading(false);
                handleCloseModalUpdate();
                if (res.success) {
                    swal({
                        text: res.message, icon: "success", timer: 2000, dangerMode: false,
                    });
                    getCouponCodes();
                } else {
                    swal({
                        text: res.message, icon: "error", timer: 2000, dangerMode: false,
                    });
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };


    const getCouponCodes = (page = 1) => {
        setIsLoading(true);
        getWithAuthCallWithErrorResponse(ApiConfig.GET_ALL_COUPON + `?page=${page}&pageSize=${perPage}`)
            .then((res) => {
                let data = res.json;
                setIsLoading(false);
                if (data?.status && data.status === 200) {
                    setCouponCodes(data.list || []);
                    setPerPage(data.per_page || 15);
                    setNumPages(data.num_pages || 1);
                    setCurrentPage(data.current_page || 1);
                } else {
                    setCouponCodes([]);
                }
            }).catch((err) => {
            setIsLoading(false);
            console.log(err);
        });
    };

    useEffect(() => {
        getCouponCodes(currentPage);
    }, [currentPage]);

    const handleEditShow = (couponCode) => {
        setEditCouponCodeData({
            id: couponCode.id,
            name: couponCode.name,
            code: couponCode.code,
            type: couponCode.type,
            value: couponCode.value,
            start_date: new Date(couponCode.start_date).toISOString().split('T')[0],
            end_date: new Date(couponCode.end_date).toISOString().split('T')[0]
        });
        setShowModalUpdate(true);
    };

    return (<main
        id="cx-main"
        className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
        <div className="heading-btn-main">
            <div className="heading-common">
                <label htmlFor="">COUPON CODES</label>
            </div>
            <div className="add-btn">
                <button onClick={handleShowModalAdd}>
                    ADD COUPON CODE
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                    >
                        <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z"/>
                    </svg>
                </button>
            </div>
        </div>

        <Modal
            show={showModalAdd}
            onHide={handleCloseModalAdd}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>ADD COUPON CODE</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="row align-items-center">
                        <div className="col-md-12 mb-3">
                            <Form.Label column={'sm'}>Name</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                value={addCouponCodeData?.name}
                                onChange={(e) => {
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, name: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Your Code.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-12 mb-3">
                            <Form.Label column={'sm'}>Code</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                value={addCouponCodeData?.code}
                                onChange={(e) => {
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, code: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Your Code.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Type</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                required
                                value={addCouponCodeData?.type}
                                onChange={(e) => {
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, type: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Select Type</option>
                                <option value="value">Value</option>
                                <option value="percent">Percent</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Please Select Type.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Value</Form.Label>
                            <Form.Control
                                required
                                type="number"
                                defaultValue={addCouponCodeData?.value}
                                onChange={(e) => {
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, value: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Value.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                required
                                value={addCouponCodeData?.start_date}
                                onChange={(e) => {
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, start_date: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Start Date.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                required
                                value={addCouponCodeData?.end_date}
                                onChange={(e) => {
                                    if (new Date(e.target.value) <= new Date(addCouponCodeData.start_date)) {
                                        e.target.setCustomValidity("End Date must be greater than Start Date.");
                                    } else {
                                        e.target.setCustomValidity("");
                                    }
                                    setAddCouponCodeData({
                                        ...addCouponCodeData, end_date: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter End Date.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <Modal.Footer>
                        <div className="buttons-modal">
                            <button className="me-2" type="button" onClick={handleCloseModalAdd}>
                                Cancel
                            </button>
                            <button className="" type="submit">
                                {isLoading ? <BtnLoader/> : "Add"}
                            </button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal
            show={viewShow}
            onHide={handleViewClose}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>CATEGORY DETAILS</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">Name:</label>
                    </div>
                    <div className="col-3 ">
                        <span>Mangesh </span>
                    </div>
                </div>

                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">Status :</label>
                    </div>
                    <div className="col-3 ">
                        <span>Inactive </span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={deleteShow}
            onHide={handleDeleteClose}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="delete-msg text-center">
                    <label htmlFor="">Are you sure you want to delete?</label>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <div className="buttons-modal">
                    <button className="me-2" type="submit" style={{backgroundColor: "red"}}
                            onClick={deleteCategory}>
                        {isLoadingDelete ? <BtnLoader/> : "Delete"}
                    </button>
                    <Link to="#" className="" onClick={handleDeleteClose}>
                        Cancel
                    </Link>
                </div>
            </Modal.Footer>
        </Modal>

        <Modal
            show={showModalUpdate}
            onHide={handleCloseModalUpdate}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>EDIT COUPON CODE</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmitFormUpdate}>
                    <div className="row align-items-center">
                        <div className="col-md-12 mb-3">
                            <Form.Label column={"sm"}>Name</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                value={editCouponCodeData?.name}
                                onChange={(e) => {
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, name: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-12 mb-3">
                            <Form.Label column={"sm"}>Code</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                value={editCouponCodeData?.code}
                                onChange={(e) => {
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, code: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Type</Form.Label>
                            <Form.Select
                                aria-label="Default select example"
                                required
                                value={editCouponCodeData?.type}
                                onChange={(e) => {
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, type: e.target.value,
                                    });
                                }}
                            >
                                <option value="">Select Type</option>
                                <option value="value">Value</option>
                                <option value="percent">Percent</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Please Select Type.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Value</Form.Label>
                            <Form.Control
                                required
                                type="number"
                                defaultValue={editCouponCodeData?.value}
                                onChange={(e) => {
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, value: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Value.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                required
                                value={editCouponCodeData?.start_date}
                                onChange={(e) => {
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, start_date: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Start Date.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>End Date</Form.Label>
                            <Form.Control
                                type="date"
                                required
                                value={editCouponCodeData?.end_date}
                                onChange={(e) => {
                                    if (new Date(e.target.value) <= new Date(editCouponCodeData.start_date)) {
                                        e.target.setCustomValidity("End Date must be greater than Start Date.");
                                    } else {
                                        e.target.setCustomValidity("");
                                    }
                                    setEditCouponCodeData({
                                        ...editCouponCodeData, end_date: e.target.value,
                                    });
                                }}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter End Date.
                            </Form.Control.Feedback>
                        </div>
                    </div>

                    <Modal.Footer>
                        <div className="buttons-modal">
                            <button className="me-2" type="button" onClick={handleCloseModalUpdate}>
                                Cancel
                            </button>
                            <button className="" type="submit">
                                {isLoading ? <BtnLoader/> : "Save Changes"}
                            </button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>


        <div className="table-wrapper">
            <div className="headerFlex">
                <div className="innerLabel">
                    <label className="labelTxt">
                        Total Records : {couponCodes.length}
                    </label>
                </div>
            </div>
            {isLoading ? (<Loading/>) : (<Table striped hover id="Categories" class="table display">
                <thead>
                <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Coupon Code</th>
                    <th>Type</th>
                    <th>Discount</th>
                    <th>Expire</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {couponCodes?.length > 0 && couponCodes.map((couponCode, index) => {
                    if (!couponCode.is_deleted) {
                        return (<tr key={"couponCode" + index}>
                            <td>{index + 1}</td>
                            <td>{couponCode?.name ? couponCode?.name : ""}</td>
                            <td>{couponCode?.code ? couponCode?.code : "NA"}</td>
                            <td>{couponCode?.type ? couponCode?.type : "NA"}</td>
                            <td>{couponCode?.value ? `${couponCode.value}${couponCode.type === 'percent' ? '%' : ''}` : "NA"}</td>
                            <td>{couponCode?.end_date ? new Date(couponCode.end_date).toLocaleDateString('en-GB', {
                                day: '2-digit', month: 'short', year: 'numeric'
                            }) : "NA"}</td>

                            <td className="action">
                                <Link to="#" className="icon"
                                      onClick={() => handleEditShow(couponCode)}>
                                    <img src={ic_edit} alt="Edit"/>
                                </Link>
                                {/* <Link to="#" className="icon" onClick={handleViewShow}>
                                    <img src={ic_eyes} alt="" />
                                  </Link> */}
                                <Link to="#" className="icon"
                                      onClick={() => handleDeleteShow(couponCode.id)}>
                                    <img src={ic_delete} alt=""/>
                                </Link>
                            </td>
                        </tr>);
                    }
                    return null;
                })}
                </tbody>
            </Table>)}
            <div className="d-flex justify-content-end">
                {couponCodes && couponCodes.length > 0 ? (<PaginationCustomer
                    changePage={changePage}
                    pageCount={numPages}
                    currentPage={currentPage}/>) : (<div>
                        <h5 style={{color: "red"}}> Records Not Found</h5>
                    </div>)}
            </div>
        </div>
    </main>);
};

export default CouponCode;
